import { render, staticRenderFns } from "./OrderDetailFlightView.vue?vue&type=template&id=50d98903&scoped=true"
import script from "./OrderDetailFlightView.vue?vue&type=script&lang=js"
export * from "./OrderDetailFlightView.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailFlightView.vue?vue&type=style&index=0&id=50d98903&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d98903",
  null
  
)

export default component.exports